import React from 'react';

import { getSystemSettings } from '../../../utils/SettingsRetriever';

import './sun.scss';

export default function SunAnimation(props) {
    const configuration = getSystemSettings();

    let sun = false;
    if(! !configuration.assets.loading.sun) sun = configuration.assets.loading.sun;

    if(!sun) return '';

    return (
        <React.Fragment>
            <div className="loadingAnimation">
                <div className="sun" style={ {'backgroundImage': "url('"+sun+"')"} }>
                    &nbsp;
                </div>
            </div>
        </React.Fragment>
    )
}
